<template>
  <div>
    <header>
      <HeaderTalkshows />
      <BreadcrumbList />
    </header>
    <div id="main">

        <section class="report">

            <div class="reportTitle">
                <div class="inner4">
                    <h1>トークショーレポート</h1><p class="titleSub">Talk Show Reports</p>
                </div><!-- /inner4-->
            </div><!-- /reportTitle-->

            <section class="reportVhead reportVhead02">
                <div class="inner4">
                    <h1><img class="" src="/img_report_nikon/title.png" srcset="/img_report_nikon/title@2x.png 2x" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" /></h1>
                </div><!-- /inner4-->
            </section><!-- /reportVhead-->

            <div class="reportBody reportBodyNij">

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                        2020年9月20日（日）～10月31日（土）、初のオンライン開催となった東京カメラ部2020写真展 Online Exhibition「それでも世界は美しい。」。<br><br>
                        写真展に連動し、サポート企業様、省庁・自治体様のご提供によってオンライントークショーが開催されました。<br>
                        10月17日（土）、18日（日）は、「ニコンイメージングジャパン  フルサイズミラーレスで出会う美しい世界」というテーマで、東京カメラ部10選の半田菜摘さんと梶原憲之さんにご出演いただき、ニコンZシリーズで撮影された作品の紹介とニコンZの魅力を語っていただきました。
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="partMenu">
                    <div class="inner4">
                        <a href="javascript:void();" @click="setPage(1)" :class="{ location: pageNo == 1 }">前編：10月17日（土）</a>
                        <a href="javascript:void();" @click="setPage(2)" :class="{ location: pageNo == 2 }">後編：10月18日（日）</a>
                    </div><!-- /inner4-->
                </section><!-- /partMenu-->

                <section class="part01" v-if="pageNo==1">
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              東京カメラ部運営 塚崎（司会）「みなさん、こんばんは。本日はニコンイメージングジャパン『フルサイズミラーレスで出会う美しい世界』と題しまして、半田菜摘さんと梶原憲之さんをお迎えしてお送りいたします。まずは半田さん、よろしくお願いいたします」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->
                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-01.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              半田「この写真はエゾモモンガです。冬、森を散策しているときに出会いました。雪の上にパラパラと葉っぱの食べカスが落ちていたんです。それでここが動物の餌場なんだとわかり、上を見たらこの子が松の葉っぱを食べていました」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-02.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              半田「山にもよく登ります。後ろに見えるのは愛別岳という三角の形がきれいな山です。その手前にちょうど三角の岩があって、そこにシマリスがちょこんと乗ってくれたので、面白いなと思い、上手く山と重なるように移動して撮りました。動物だけでなく山の背景もわかるような写真を撮りたいと思っているので、そういう意味でも大好きな一枚です」<br><br>

                              塚崎「『どんなレンズをお使いですか』という質問が来ています」<br><br>

                              半田「このときはAF-S NIKKOR 80-400mm f/4.5-5.6G ED VRを使っています。400mm相当で、山肌をはっきりさせたかったので少し絞っています」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-03.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              半田「エゾフクロウの赤ちゃんです。私がニコンを使うきっかけになった写真です。エゾフクロウの雛が同じ枝に4羽並んでいるだけでも珍しいのに、かつ同じ方向に目線が揃っている瞬間です。こういう奇跡の瞬間をクオリティ高く残したいと思っていたのですが、この日は雨が降っていて暗く、使っていたレンズも他社のズームレンズだったので、F値が上がり、ノイズが乗って透明感が失われてしまいました。どうせだったら大きいレンズを使って明るいきれいな写真を撮りたいと思ったんです。元のメーカーではそういうレンズが無かったのもありまして、ニコンに変えました」<br><br>

                              塚崎「『何のモードで撮っていますか？シャッタースピードはどれくらいですか？』という質問が来ています」<br><br>

                              半田「モードはマニュアルです。シャッタースピードはできるだけ速いほうが良くて、ISO感度との兼ね合いにもなりますが、飛びものはできれば1/1600秒くらいは欲しいです。このときのように止まっている被写体ですと1/100秒や1/80秒でもいいと思います」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-04.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              半田「動物を撮るときに一番大切なのは、AFの速さと正確さ。ニコンを使い始めてから驚くほどストレスがなくなったんです。それまでは後ろにピントが引っ張られたり、AFが迷うことがあって、カメラのせいで撮れないな、と思ってしまうこともあったのですが、ニコンに変えてからはそれがほぼなくなりました。逆にニコンのカメラで撮れなかったら自分の実力不足だと思えるくらいしっくりきたんです。今もそれは変わらなくて、私がニコンを使い続けている理由です。このときは実は違う鳥を撮るために待っていたのですが、川の上流から鳴き声がして、すぐにヤマセミが降りてきたので、振り返りざまに撮った一枚です。それくらい急なシチュエーションでもAFを合わせてくれました。レンズはAF-S NIKKOR 80-400mm f/4.5-5.6G ED VRで撮影しました」<br><br>

                              塚崎「確か、最初に購入したのはAF-S NIKKOR 600mm f/4E FL ED VRですか？」<br><br>

                              半田「そうです（ライブ画面で実物のレンズを見せながら）。画面からはみ出るほど大きいですね。最初にいきなりD810とAF-S NIKKOR 600mm f/4E FL ED VRと三脚とを買って、覚悟を決めました」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-05.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              半田「羅臼で撮った写真です。この写真も、撮れたのはニコンのカメラのおかげだと思っています。日本で唯一野生のシャチが見られるのが羅臼町で、シャチを見るためのクルーズ船が出ているんです。でも、そもそもクルーズ船に乗ったからと言って必ず見られるわけではなくて、たまたまこの日はシャチの群れに当たって、なおかつ船の真横でジャンプしてくれました。すごくレアなことです。私は二階デッキから見ていて、一回目は逃してしまったのですが、二回目は構えていたので撮影できました。運がいいのと、カメラの性能のおかげですね」<br><br>

                              塚崎「『一番好きなレンズは？』という質問が来ています」<br><br>

                              半田「今好きなのが、AF-S NIKKOR 500mm f/5.6E PF ED VRという単焦点レンズです。500mmなのにこの小ささと軽さで、すごくクオリティが高いですし、光の取り込み方がきれいです。透明感のある写真が撮れると思います」<br><br>

                              塚崎「『ニコンのカメラはどの機種がおすすめですか？』という質問です」<br><br>

                              半田「最近Z 7IIを使わせていただいたのですが、軽くて操作もしやすくて、すごくオススメですね。初心者でも簡単に使えると思います」<br><br>

                              塚崎「写真を簡単に撮りたいんだったら、高いカメラを買おうと言うのはありますね」<br><br>

                              半田「それは言えると思います。安かろう悪かろうの逆で、良いものは高い理由があります。私も最初は入門機を買ったのですが、やはり写真にハマっていくと自ずと高いものに行き着くので、最初から高いものを揃えるのは手かもしれません」<br><br>

                              塚崎「『撮影で気をつけていることは？』という質問が来ています」<br><br>

                              半田「まずは安全に、ということです。私はすごく運動音痴ですし体力がないので、無茶はしないようにしています。自分が確実に行ける場所を選んで歩いていますし、あとはヒグマに出会うこともあるので、必ず撃退用のクマスプレーを持って歩いています」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-06.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              半田「ウサギを撮るために山に入っていたところ、エゾタヌキの番いを見つけまして、AF-S NIKKOR 500mm f/5.6E PF ED VRを持って木に隠れて撮っていました。タヌキたちが餌を探してどんどん近づいてきて、撮れたのが次の写真です」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-07.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              半田「玉ボケがとてもきれいです。単焦点レンズなので、自分が下がらないとどんどんタヌキが迫って来て見切れてくるんですね」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-08.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              半田「ついにはこうなってしまいました。立ち上がったら驚かせてしまうかなと思い、撮影をやめて黙って木を見ていたので、タヌキが不思議がってどんどん近づいてきたんです」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-09.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              半田「本当に近くて、逆に少し怖いくらいでした。私が黙って木を見ていたのが不思議だったのか、覗き込むようにどんどん近づいてきました。足を崩したときにストラップの金具が鳴ってしまって、その音に驚いたのか遠くに逃げて行きました。人馴れしていない子だったのですが、こんなことあるんだなぁと思いましたね」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-10.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              半田「私はなるべく動物の自然な感じを撮りたいので、ある場所でじっと待って撮ることが多いです。赤丸で囲ってあるのはカエデの木。アカゲラというキツツキが木を突くと甘い樹液が出てくるので、シマエナガが来ると思ってじっと待っていました。青い矢印の部分は段差になっているので、そこに座って待っていました。大体2時間くらい待ったと思います」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-11.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              半田「こんな写真が撮れました。このように来るかなと思って待って、実際に来てくれた時は本当にうれしいですね。シマエナガのように小さな鳥は追うと逃げてしまうので、来そうな場所で待つのが一番確実だと思っています。2〜3時間おきに戻って来ることが多いので、最低2時間は待つといいのかなと思います」<br><br>

                              塚崎「『Z 7は使いやすいですか？』という質問が来ています」<br><br>

                              半田「使いやすいですよ。特によく晴れた日は、日陰は暗くて日が当たっているところは白飛びするくらい明るいじゃないですか。そういうときにEVFを覗くと露出が反映されて見えているので、操作がすごく楽ですよね」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-12.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              半田「左下に写っているのはエゾナキウサギです。エゾナキウサギは名前の通り、ナワバリを主張するためにピッピッピッと鳴くんです。鳴いて口を開けている瞬間を、タイミングを合わせて撮りました。冬眠はせずに巣にご飯を溜め込んで、雪解けになるまで葉っぱを食べて生活しています。なので冬は基本的には外に出てこないのですが、たまに出てくるその瞬間を撮りたくて雪山に入りました。絶対に出てくるとは限らないので、秋のうちにこの子のナワバリを観察しておいて、出てきそうな場所を絞って待ちました。雪山って、雪が音を吸収するからとても静かなんです。なのでシャッター音が気になるシチュエーションもあるのですが、このときはZ 7の「電子シャッター」を使用したサイレント撮影をしているので、全く音がしない。自分が動いたときの洋服が擦れる音が気になるくらいです」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-13.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              半田「エゾクロテンというイタチ科の動物です。この写真もZ 7で撮影しています。私、四つ足動物の毛並みを拡大して見るのが好きなんです。この子もヒゲの点々の部分を拡大して見るのがすごく楽しくて。そういう意味で、私は高解像度のカメラが自分には合っているなと思います」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-14.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              半田「外来種ですが、ルピナスというきれいな色の花です。5年くらい前からいつかエゾシカと絡めて撮れたらいいなと思っていたので、今年チャレンジしてみました。エゾシカが来るかわからないけれど、ルピナスが群生しているところで待ってみようと思い、9時間くらい待ちました。後ろの暗くなっている部分が山肌なのですが、そこから日没くらいの時間に降りてきてくれました。暗いシチュエーションでしたが、Z 7だとノイズも気にならないですね」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-15.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              半田「コミミズクという鳥です。いつも遠くを飛んでいるのを見ているだけだったのですが、このときたまたま頭上を飛んできてくれた瞬間です。これもZ 7です。慌てて撮ったのですが、ちゃんとピントが合っていますし、こんなにくっきり撮れたのは初めてでした。羽が透けていてとてもきれいです。よく見ると足に血がついているので、狩をした後だと思います」<br><br>
                              塚崎「半田さん、ありがとうございました。続いては梶原憲之さんです。梶原さんはお子さんと風景を一緒に撮っていらっしゃるのですが、写真を撮るきっかけは何だったのでしょうか」

                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-16.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              梶原「元々学生時代からインスタントカメラを使っていて、子どもを撮るためにデジタル一眼レフカメラを買いました」<br><br>

                              塚崎「ニコンを使うようになったきっかけを教えてください」<br><br>

                              梶原「まだカメラの知識が浅いとき、ニコンに対して『プロの方が使う』というイメージを持っていて、プロの方が使うのであればいい写真が撮れるだろう、という発想で選びました」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-17.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              塚崎「この写真すごく好きです。構図があまりにも完璧ですよね。撮影地はどうやって探しているんですか？」<br><br>

                              梶原「Googleマップで探しています。Instagramのハッシュタグも駆使しています。この写真は山口県の秋吉台ですね。スカートがなびいているのは自然の風のおかげです。タイミングを合わせてシャッターを切りました」<br><br>

                              塚崎「レンズは何を使っているんですか？」<br><br>

                              梶原「レンズはNIKKOR Z 24-70mm f/4 Sのキットレンズを使っています。この写真の画角は35mm相当だと思います」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-18.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              梶原「山梨県の八代ふるさと公園という場所です。土手に見えるかもしれませんが、古墳の上なんです。山梨は地形的に入道雲が発生しやすいですね」<br><br>

                              塚崎「まるで絵のような雲です。理想の形になるまで待つんですか？」<br><br>

                              梶原「このときは30分くらい待ちました。子供達は虫取り網を持って無邪気に遊んでいたので、今だ！というタイミングで焦って呼びに行きました」<br><br>

                              塚崎「『撮影のときは、三脚は使いますか？』という質問が来ています」<br><br>

                              梶原「薄暗い状況で時々使いますが、基本的には使わないです。手持ちで撮影しています」<br><br>

                              塚崎「それから『撮るときに、離れたお子さんとの意思疎通はどうしていますか？』という質問も来ています」<br><br>

                              梶原「大声を出してますね（笑）電話などは使わないです」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-19.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              梶原「ここは、兵庫県の武田尾廃線です。廃線なので、昔電車が通っていた場所です」<br><br>

                              塚崎「偶然リフレクションになっているんですか？」<br><br>

                              梶原「雨が多い時期には水溜りができるとわかっていたので、狙って行きました。4年前に1人で行ったときに発見した場所なんです。ここを撮影で使用したらいい写真が撮れるんじゃないかと。水溜りの情報はGoogleマップでは出てこないですよね」<br><br>

                              塚崎「東京カメラ部では毎日4万枚写真を投稿してもらっているので、大抵の撮影スポットはわかるのですが、梶原さんの撮影場所はどこ？と思うことが本当に多いです」

                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-20.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              梶原「ここは岡山県の山乗渓谷です。有名な滝があるのですが、敢えて写真には入れずに滝を背にして撮りました。NIKKOR Z 70-200mm f/2.8 VR SというZレンズを使用しています」<br><br>

                              塚崎「学生時代からインスタントカメラを使用するなど、色々なカメラをお使いだと思います。やはりミラーレスになって便利になりましたか？」<br><br>

                              梶原「はい、とても便利ですね。きれいに撮れるし、高感度にも強いので。液晶を動かせば、カメラを水面近くまで近づけて撮れて便利ですし、やはり荷物は小さい方がいいので。僕は登山もするので、あまり重いものを首からぶら下げて歩いていると肩が凝ってしまいますよね」<br><br>

                              塚崎「『構図で気をつけていることはありますか？』という質問が来ています」<br><br>

                              梶原「構図の勉強は主にインターネットです。上手い人の写真を良く見て研究しています。格子点にしっかり合わせるのが基本だと思います」<br><br>

                              塚崎「『ボディとレンズの組み合わせを教えてください』という質問が来ています」<br><br>

                              梶原「カメラはZ 6で、レンズは広角から望遠まで一通り持っています」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                      <div class="inner4">
                          <img class="" src="/img_report_nikon/1-21.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                      </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              梶原「熊本の阿蘇です。Z 6はダイナミックレンジが広いので、こういった逆光での撮影にすごく強いですね。強い光だったのでアンダーで撮影したのですが、後から持ち上げてもノイズが出ないです。レンズはNIKKOR Z 14-30mm f/4 Sを使用しています。フレアも出ず、破綻しない写りですね。僕は基本的には絞り優先で撮っていて、この写真はF14で撮影しています。光芒が出るように意識して絞っています」<br><br>

                              塚崎「ここで、梶原さんからご覧の皆さんに質問があるんですよね」<br><br>

                              梶原「はい。僕は、カメラは大きいものが良いと思っていたのでなかなかミラーレスに踏み切れなかったんです。そういった考えの方っていらっしゃいますか？」<br><br>

                              塚崎「『大きい方が安定感があるという印象がありますね』『持ち運びしやすいのでZに変えました』『D750からD850に変えました。ミラーレスはファインダーの絵がまだ慣れなくて…』」と様々なご意見が来ています」<br><br>

                              梶原「なるほど。ミラーレスはファインダーを覗いた絵がそのまま撮れるので、そこが大きな利点でもありますよね。僕も最初は大きな一眼レフを使っていたのですが、Z 6は僕の撮影スタイルにどんどん馴染んでくれる良いカメラだと実感しています」<br><br>

                              塚崎「ご覧いただいた皆さん、たくさんのご意見をくださり、ありがとうございます。梶原さん、本日は素敵なお写真とお話をありがとうございました」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="movBlock movBlockNij">
                      <div class="inner4">
                          <h2>このレポートのアーカイブ動画</h2>
                          <iframe width="560" height="315" src="https://www.youtube.com/embed/Y-iXRliU034" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      </div><!-- /inner4-->
                  </section><!-- /movBlock-->

                </section><!-- /part01-->

                <section class="part02" v-if="pageNo==2">
                  <section class="txtBlock">
                      <div class="inner4">
                          <p>
                              塚崎「みなさん、こんばんは。ニコンイメージングジャパン『フルサイズミラーレスで出会う美しい世界』インスタライブの後編がはじまります。本日も東京カメラ部10選の半田菜摘さんと梶原憲之さんにご出演いただき、おふたりの作品をご覧いただきながら、Nikon Zシリーズの素晴らしさを体験いただければと思っています。まずは半田さんから、Z 7IIで撮られた写真を中心にご紹介いただきます。それでは最初の作品のご紹介をお願いします」
                          </p>
                      </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-01.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              半田「これはクマタカという猛禽類の大きな鳥です。北海道はちょうど紅葉の季節だったので、クマタカと紅葉を撮ろうと思い、クマタカがよく来る谷に行きました。夜明け前からテントに入り、クマタカが来るのを待ちました。谷に降りればもっとアップでも撮れたかなと思うのですが、撮影期間が短かったので、山肌を舐めるようなものしか撮ることができませんでした。レンズはNIKKOR Z 70-200mm f/2.8 VR Sに1.4倍のテレコンを付けていたので、最大でも300mmでしか撮ることができず、ちょっと小さめにはなってしまっています」<br><br>

                              塚崎「新しいカメラを使って作品をご紹介いただくのは実はとても大変で、とても限られた時間で撮るしかないんです。また動物写真は特に大変ですよね。天候の影響も受けてしまううえに、動物が必ずしも来てくれるとは限らないという。そこはご理解いただきたいです。みなさまからコメントも来ています。『作品はレタッチをしているのですか？』という質問が来ています」<br><br>

                              半田「していないです。まだ現像ソフトが対応していない段階で撮影をしていたので、JPEG撮って出しになります。少し露出調整はしたものもありますが。そしてこれはシングルフォーカスで撮影しています」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-02.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              塚崎「発売する前にテスト撮影しているので、必然的にレタッチしようがないですね。そして実際の写真はこうなんですよね？」<br><br>

                              半田「かなりトリミングをしているんですよ。山肌を舐めるように飛んでいるだけなので、実際には小さくしか写っていないんです。画素数が大きいので、その恩恵を受けてトリミングしました」<br><br>

                              塚崎「画素数が上がった恩恵は描写力だけでなく、トリミングができるという点も大きいですよね」<br><br>

                              半田「動物撮影だと、どんなに望遠レンズを付けていても限界がありますし、動物にストレスを与えてしまったり逃げてしまったりすることもあるので、トリミングできるに越したことはないと思っています」<br><br>

                              塚崎「一般的には近づいて撮るということは基本かもしれませんが、動物撮影の場合、動物にストレスを与えることにもなりますし、安全性のこともありますから、トリミングはある意味で正義ですよね」<br><br>

                              半田「私は積極的に使っています。動物に嫌な思いをさせてまでは撮りたくないので」<br><br>

                              塚崎「質問が来ています。『Z 7IIに望遠ズームとテレコンを付けると、重量はどのような感じですか？』」<br><br>

                              半田「女性の私が持っても軽いです。片手で持てるくらいです」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-03.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              半田「こちらもZ 7IIで撮ったキタキツネの写真です。私は今までシングルフォーカスしか使ってこなかったんですが、ニコンの方から瞳AFがとても良くなったということを聞いたので、初めてこの時に使ってみました。感動するくらい素晴らしかったですね。草むらにキタキツネがいたんですが早歩きで、普通に撮っていると手前の草にピントが合ってしまうシチュエーションでしたが、瞳AFを使ったら草が覆っていてもそのままキタキツネを追い続けてくれて99％くらいの確率でピントは合いましたね」<br><br>

                              塚崎「動物はもう一回撮る、が効かないですからね」<br><br>

                              半田「そのときそのときで集中しないと撮れないので、これからも瞳AFは積極的に使おうと思いました」<br><br>

                              塚崎「動物園と違い被写体側が身を隠したりもするのでフォーカシングは難しいですよね」<br><br>

                              半田「私は眼にピントが合っていないと、よほど意図がない限り作品としては発表できないと思っているので、瞳AFはありがたいですね」<br><br>

                              塚崎「撮影のハードルは下がりますよね」<br><br>

                              半田「簡単に撮ることができる時代になってきているので、表現することが難しくなってきますね。どんどん皆のレベルが上がってくるので」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-04.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              半田「このくらい離れていても顔からピントが外れることはなかったです。日没間際でかなり暗かったんですけど、それでも外れなかったですし、JPEGでもノイズが目立たないくらいの描写です」<br><br>

                              塚崎「写真家は、『写真を撮る技術』『構図を作り上げる表現の技術』が必要ですが、動物写真家の場合はそこに『動物の知識』というものも必要になってくると思います。このうち、撮る技術というのはカメラの進化でグッと楽になってくるので、あとは構図の技術や動物の生態を知ることが大切になってくるのでしょうね」<br><br>

                              半田「生態を知ることで、次はこういうシチュエーションを撮りたいとか、こういう写真は見たことがないから切り取りたいとかがイメージできると思うんです。それに合わせてさらに情報を調べたり機材を用意したり、そういうプロセスも含めて動物写真はおもしろいですね」<br><br>

                              塚崎「『連写ですか？』という質問が来ています。半田さんは連写をあまりお使いになりませんよね」<br><br>

                              半田「クマタカのときは、Zシリーズはサイレントモードでシャッター音も消すことができるので連写をしましたが、このように動きのないシチュエーションであれば連写する必要はないと思っています」<br><br>

                              塚崎「『Z 7からZ 7IIでのAFの進化やEVFの見え方が気になります』という質問も来ています。いかがでしょう」<br><br>

                              半田「EVFの見え方の差は感じないですが、AF精度は格段に上がったと思います。AFの精度は命です。私はカメラで最も重要視しています」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-05.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              塚崎「先ほど機材が進化していると話しましたが、その進化を活かす取り組みが見て取れる作品を拝見したいと思います」<br><br>

                              半田「木の幹に3匹のエゾモモンガがいる写真です。これはZ 7を木に吊して遠隔操作で撮っているんですけども、Bluetoothでカメラとスマートフォンをペアリングすることで、スマートフォン からシャッターを切ることができるんです<sup>※</sup>。その機能がおもしろいと思い、こういう撮影方法を考えて撮りました。ずっと同じ撮り方をして自分が進化しなければ、カメラが進化をしても活かすことができないので、あまり見たことがない構図で撮りたいな、と思い撮影方法を考えました」<br>
                              <span class="attention">※SnapBridge：ニコンのカメラとスマートフォン/タブレット端末をシームレスにつなぐアプリケーション。詳しくは<a target="_blank" href="https://www.nikon-image.com/products/software_app/lineup/snapbridge/">こちら</a></span><br><br>

                              塚崎「写真の変化はカメラの向きというよりも高さが変わることと言いますが、これは好例ですね」<br><br>

                              半田「セッティングは大変でした。ただ吊すだけだと、風が吹くだけでカメラが回ってしまったり、ちょっとしたブレで構図が変わってしまうので、3箇所からピンとカメラを固定してブレないようにしました」<br><br>

                              塚崎「また、ここは半田さんの山なのでそういうことができるんですよね」<br><br>

                              半田「はい。私が借りている山で撮影しました。テントも残置してスマホを見ながら撮影しています。私しかいない場所なので好きにしていますが、夜はモモンガが滑空していて引っかからないように、ロープなどは必ず片付けてから帰るようにしていますね。この角度はドローンでも無理だと思います。この時はNIKKOR Z 70-200mm f/2.8 VR Sを吊していて、かなりエゾモモンガと近い位置からの撮影です」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-06.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              塚崎「同じくエゾモモンガの作品です」<br><br>

                              半田「こんども下から上に向けての構図で撮影しています。こうすることで、エゾモモンガが暮らす雰囲気が伝わると思いますし、薄暗くなってエゾモモンガの活動時間となり、ひょっこり出てきたというのが表現できるかなと思い、超広角のNIKKOR Z 14-24mm f/2.8 Sを付けてセットしました。私は離れてテントの中からスマートフォンからシャッターを押しただけです。巣穴の真下に置いているので、おしっこなどで汚れないようにカメラとレンズのマウント部はタオルで巻いて設置しました。「耐水性」は謳っていますが、『おしっこ耐水性』とは説明書に書いてないので（笑）」<br><br>

                              塚崎「人間が構えていたらエゾモモンガはきっと出てこないでしょうね。コメントを拾っていきます。『熊スプレーを持ち歩いていると聞いていますが、実際に出会ったことはありますか？』という質問です」<br><br>

                              半田「何度もありますが、熊スプレーを使うようなシチュエーションはないです。向こうも気付いて去ってくれるというのがほとんどです」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-07.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              半田「これはエゾナキウサギという動物で、山の上に住んでいるウサギの仲間ですが、これも遠隔操作でシャッターを切っています。というのは、レンズはNIKKOR Z 14-24mm f/2.8 S、ナキウサギは通る道が決まっていて、また乗っかる岩もだいたい分かるんですね。だから、お気に入りの岩の前にカメラを置いて来るのを待ち、私は離れたところからスマホでシャッターを切っています。こういう撮り方をすることで、ナキウサギの生活も撮ることができます」<br><br>

                              塚崎「これは悪いという話ではないんですが、動物をズームして撮ると、動物園で撮れる写真になってきてしまいます。こういう環境で生きているんだ、ということが分かる半田さんの写真はそれとは違います」<br><br>

                              半田「それが伝わると嬉しいです。過酷な環境で生きているんだなとか」<br><br>

                              塚崎「餌の少なそうな場所ですね」<br><br>

                              半田「横に生えている草を取りいき、岩の下に草を隠したり、その場で食べたり。かわいい写真も好きですが、その中で見せる逞しさも写真で表現できればと思っています」<br><br>

                              塚崎「質問にいきます。『遠隔操作はスマホですか？』とのことですが」<br><br>

                              半田「はい、スマホです。液晶画面上から露出の設定も行うことができます。そのまま露出を反映した画面をスマホ上で見ることができるのでとても楽しいです。その場で設定を変えられるので、晴れと曇りがころころと変わるような時も大丈夫です」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-08.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              塚崎「もう1枚のナキウサギの写真では、まさにこういう環境で生きているんだというのがよく分かります」<br><br>

                              半田「岩の間にご飯を貯め込む修正があり、右下の茶色い部分が実際にナキウサギが運んできたご飯になります。雪の下でこれを食べて雪解けを待つんです。こういう写真は撮れそうで撮れないんです。葉っぱを持って埋めに来るんですけど、人間がいたら警戒して近づいてきません」<br><br>

                              塚崎「遠隔操作という機能がなければ撮れなかった写真ということですね」<br><br>

                              半田「遠くから狙えば撮れるかもしれませんが、臨場感は出ないと思います」<br><br>

                              塚崎「機能が入ることで写真家の表現領域が広がっているんですね」<br><br>

                              半田「先ほど、キタキツネを薄暗い中で捉えた写真をご紹介しましたが、これからは今までは諦めていた夜の動物の撮影が可能になってくると思うので、それをどう表現してくかも楽しみです」<br><br>

                              塚崎「夜でもAFが合うと、今までは撮れなかった生態が撮れるようになるということですね」<br><br>

                              半田「腕の見せどころになるかもしれません。いや、自分で言っておきながらプレッシャーですね。最近、ずっと撮りたかった星空と動物の写真を撮ることができたんですね。ISOをグッと上げて撮ることができたので、いずれそれも発表したいと思っています」<br><br>

                              塚崎「質問に移ります。『Z 6の瞳AFで猫を撮っているんですが、Z 7IIはZ 6の瞳AFよりも進化しているのか気になります』ということです」<br><br>

                              半田「私はZ 6では瞳AFを使ったことはないのでわかりませんが、純粋なAFであれば進化しています。それはクマタカの撮影で実感しましたね」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-09.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              塚崎「最後に、写真を撮るようになって良かったという点をお話いただきたいです」<br><br>

                              半田「私は病棟看護師の仕事をしており普段は夜勤もあるんですけれど、病院で私の写真を飾ってくれたり、売店でポストカードを販売してくださったりしています。例えば写真の患者さんは、骨折後のリハビリ療養目的で入院されたんですが、どうしてもリハビリが辛いときとかあるじゃないですか。その時に私の写真を床頭台に飾ってくださっていて、『辛いときはそれを見て頑張るんだ、元気をもらっているんだ』って。私はそれを聞いて嬉しすぎて、スマホで写真を撮らせていただいたんです。写真が誰かのポジティブな気持ちに寄り添えたら嬉しいじゃないですか」<br><br>

                              塚崎「『我ら、看護師フォトグラファーの星です』というコメントが来ています」<br><br>

                              半田「写真を撮る看護師の方からよくメッセージをいただきます。そしてそれを見て励まされています」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-10.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              塚崎「東京カメラ部2020写真展のタイトルは『それでも世界は美しい。』というものですが、半田さんが世界の美しさを発見した時とはどんな時でしょう」<br><br>

                              半田「写真をやっていて良かったなと思うのは、今までは目に留まらなかったものが輝いて見えることですかね。この写真も、元々開拓が入っていて今は森に戻りつつあるような場所を散策している時に見つけたんですが、ガードレールを木が成長しながら飲み込んでいっているんですよ。自然の偉大さを感じます。今までならこれを見ても何も感じなかったかもしれません。写真を撮るようになり、世界の美しさや自然のパワーを感じられるようになりました。これはすごく大きなこと。自分の人生がより豊かになると感じています」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-11.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              塚崎「こちらも同じような視点でしょうか」<br><br>

                              半田「はい。近所の公園なんですが、今まではそこまで関心なかったんですが、写真を撮るようになって、あ、秋から冬になるんだって、ちょっとした気付きができることが楽しいですよね。写真をはじめる前は、マイナス20度になると聞いたら、嫌だなあとしか思いませんでしたが、今ではダイアモンドダスト出るかなとか、ポジティブな発想になります。それはいいことですよね。カメラをはじめて本当によかったと思います」<br><br>

                              塚崎「写真を仕事と両立し、お互いが良い方向に進むというのもいいですよね」<br><br>

                              半田「そう、まさに両方が良い方向に影響しあっていると思います」<br><br>

                              塚崎「また、こうした半田さんの写真をご覧いただける場所があるのでご紹介させてください。Zシリーズで撮影された作品と共に、写真家さんのインタビューも掲載した『Zシリーズユーザーズギャラリー』や、豊富なニッコールレンズで撮られた作品を見ることができる『ニッコールレンズユーザーズギャラリー』もございます。半田さんと、この後登場する梶原さんの作品も今後追加予定ですので、ぜひご覧いただければと思います。また、ニコン製品で撮られた作品を投稿いただいている場所もあります。ニコンイメージングジャパン公式Instagramアカウント『@nikonjp』では、ニコンのカメラ・レンズで撮影され、#light_nikonというハッシュタグをつけてInstagramに投稿いただいた作品をご紹介しています。こちらも閲覧、投稿などご参加をよろしくお願いします。また、Z 7IIとZ 6IIのティザーサイトもございますので、お二人がどのようなカメラで撮影されたのか、細かい情報はこちらをご覧いただければと思います。半田さん、本日はありがとうございました。続いては梶原憲之さんです。梶原さんはZ 6IIをお使いになったんですよね。早速写真を拝見してきます」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-12.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              塚崎「これはどちらで撮影していますか？」<br><br>

                              梶原「香川県の男木島というところで猫がたくさんいるところです。猫がいることで有名です。瀬戸内海が見えます。有名な場所で、せっかくZ 6IIをお借りしたので行ってみようと」<br><br>

                              塚崎「このような撮影をするときに注意していることはなんでしょう」<br><br>

                              梶原「背景など状況を明確にすること。そして何を撮るのかをはっきりさせることを意識しています。構図はオンラインで勉強をしました。例えば三角構図など基本を抑えていくことですね」<br><br>

                              塚崎「色もいいし、三層構図にもなっているし、視線の誘導もあるし、絵画を見ているかのような構図ですね」<br><br>

                              梶原「奥行きは意識するようにしています」<br><br>

                              塚崎「Z 6IIを試してみて良かったところは？」<br><br>

                              梶原「やはりAFが格段に良くなっているという点ですね。瞳AFは、僕は背中ばかり撮っているので使うことはほぼないのですが、それ以外にも便利な機能があります。ファインダーの中にカーソルが表示されるんですね。それを子供に合わせると、構図を変えても子供が動いても追っかけてくれるんですよ。これは良いなと思いましたね。あと連写も良いですね。運動会などでもバシバシといけます。ちょうど最近運動会があったんですよ。連写をすると肝心なところでフリーズすることがあるじゃないですか。でもZ 6IIはそんなことはありませんでした」<br><br>

                              塚崎「質問が来ています。『絞りはどのくらいですか？』」<br><br>

                              梶原「単焦点レンズを使っていて、これはF2.4くらい、開き気味で撮っています」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-13.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              塚崎「Z 6IIのミラーレス機ならではの優位性は感じましたか？」<br><br>

                              梶原「これは片手で撮影しています。片手でも手が震えません。水面ギリギリまで寄せていけます。リフレクションを出すには、水面に近づけたほうがいいので」<br><br>

                              塚崎「タテの構図が多いですよね。『先ほどの話は、被写体認識のようなものですか？』という質問です」<br><br>

                              梶原「人に限らず、カーソルを合わせたものには追尾するという機能だと思います。ちなみに、この写真だけはZ 5で撮っています。レンズはキットレンズのNIKKOR Z 24-50mm f/4-6.3で撮っていますね。キットレンズでもここまで写るのはニコンの技術力、性能の高さだと思います」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-14.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              塚崎「次も味のある写真ですね」<br><br>

                              梶原「レンズはNIKKOR Z 24-70mm f/2.8 Sです。これは非常に逆光に強いレンズ。ニコンの技術が詰まっていますね。Zマウントのレンズはこの1本しか所持しておらず、あとはFマウントのものをアダプターで使用しています。このレンズはクリアに撮れ、逆光にも強いので気に入っています。またZ 6IIのダイナミックレンジは優れているので、シャドウ部を持ち上げても大丈夫ですね」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-15.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              塚崎「続いての写真です」<br><br>

                              梶原「これは熊本県<sup>※</sup>の久住にある山吹水源という場所です。九州ではとても有名なスポットです。緑の中に赤がワンポイントになっています。とても薄暗い場所で、背景は白飛びしやすいような状況でしたが、かなりアンダー露出で撮影し、後から持ち上げています。レンズはNIKKOR Z 24-70mm f/2.8 Sですからクリアに撮れますね。またこのように暗めでもAFは迷いません」<br>

                              <span class="attention">ライブ上では「大分県」とお話されていますが、正しくは「熊本県」です。謹んで訂正いたします。</span><br><br>

                              塚崎「構図はどのように決定しますか？」<br><br>

                              梶原「ファインダーを覗きながら決定します。ですから、被写体の追尾があるのはとてもありがたいです」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-16.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              梶原「これは岡山県で撮影しました。曇り、夕暮れ前で少し暗くなりつつあるという中でしたが、ISOを上げてもノイズは乗ることがないので、クリアに撮影できました。このようなシーンではアンダー露出で撮るのがいいかなと思っています」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-17.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              塚崎「写真を撮りはじめて何年ですか？」<br><br>

                              梶原「5、6年ですね。その前はインスタントカメラを使っていたりはしましたが、本格的に一眼レフで撮りはじめてからはそのくらいです。子供を撮ろうと思い始めました」<br><br>

                              塚崎「写真を撮るようになって良かったことはありますか？」<br><br>

                              梶原「普段は気にしていなかったような風景が美しいと思えるようになったことですね。僕は岡山県出身ですが、とにかく田んぼが多いんですね。小さい頃は何も感じていませんでしたが、写真をはじめてみると田んぼってきれいだなって」<br><br>

                              塚崎「そこにあるだけじゃなくて、被写体として使おうとすると、ここまできれいな写真が撮れるということですね」<br><br>

                              梶原「岡山県では6月になると水が田んぼに引かれますが、その時期になるとずっと田んぼばかり見ていますね。風が吹いていなければ、至る所が「ウユニ田んぼ」になりますから（笑）」<br><br>

                              塚崎「『写真を撮る場所はどのように決めていますか？』という質問が来ています」<br><br>

                              梶原「Googleで探します。先ほどの彼岸花の写真がありましたが、「岡山＋彼岸花」で検索をするとメジャーな場所しかヒットしないので「市町村名＋彼岸花」で検索し、これは「高梁市＋彼岸花」で見つけた場所です」<br><br>

                              塚崎「私も写真を撮るようになってからは、四季の移り変わりがとても楽しみになりました。この写真のように、田んぼも季節によって表情を変えます」<br><br>

                              梶原「緑になったり、さまざまな楽しみ方がありますよね」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-18.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              塚崎「白い雲とそれに合わせた白いドレスに赤い自転車。あざといですね（笑）。写真を撮ることで四季を感じる、というようなコメントが続々と届いています。さて、今回は『それでも世界は美しい。』というテーマで写真展を開催していますが、梶原さんが『世界は美しい』と感じられた瞬間という1枚をご紹介いただきたいと思います」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="photoBlock">
                    <div class="inner4">
                      <img class="" src="/img_report_nikon/2-19.jpg" alt="ニコンイメージングジャパン「フルサイズミラーレスで出会う美しい世界」" />
                    </div><!-- /inner4-->
                  </section><!-- /photoBlock-->
                  <section class="txtBlock">
                    <div class="inner4">
                         <p>
                              梶原「熊本県の阿蘇の大観峰という場所ですね。自然を相手に写真を撮ることは多いですが、阿蘇の自然はダイナミックがすごいうえ、写真ではうっすらとしか写っていませんが、このときは虹も出て、世界は美しいなと感じました。虹が出るときは曇っていることが多いのに青空だったことも運が良かったです」<br><br>

                              塚崎「こういう1枚が撮れると世界の美しさを実感しますね。写真のテーマに応じた分室を作っていて、山を主題とした『山のある風景写真館』、夜景、夕景、星空などを主題とした『NightscapeGallery』や、ニコンのレンズ交換式カメラ用の「NIKKOR（ニッコール）レンズ」で撮影された作品を投稿・閲覧できる『NIKKOR LENS』というFacebookページもあります。今回のインスタライブに限らず、ニコンのカメラやレンズを知りたい方、写真を楽しみたい方はこれらのページもご利用いただければと思います。梶原さん、ありがとうございました」
                         </p>
                    </div><!-- /inner4-->
                  </section><!-- /txtBlock-->

                  <section class="movBlock movBlockNij">
                      <div class="inner4">
                          <h2>このレポートのアーカイブ動画</h2>
                          <iframe width="560" height="315" src="https://www.youtube.com/embed/ZjApnl_i0yU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      </div><!-- /inner4-->
                  </section><!-- /movBlock-->
                </section><!-- /part02-->

                <section class="partMenu partMenuBottom">
                    <div class="inner4">
                        <a href="javascript:void();" @click="setPage(1)" :class="{ location: pageNo == 1 }">前編：10月17日（土）</a>
                        <a href="javascript:void();" @click="setPage(2)" :class="{ location: pageNo == 2 }">後編：10月18日（日）</a>
                    </div><!-- /inner4-->
                </section><!-- /partMenu-->

                <section class="bnrBlock3">
                    <div class="inner4">
                        <a target="_blank" href="https://www.nikon-image.com/sp/the_next_chapter/"><img src="/img_report_nikon/bnr_01.jpg" alt="THE NEXT CHAPTER Z 7II Z 6II"></a>
                        <a target="_blank" href="https://nikkor.tokyocameraclub.com/z_users_gallery/"><img src="/img_report_nikon/bnr_02.jpg" alt="Zシリーズユーザーズギャラリー"></a>
                        <a target="_blank" href="https://nikkor.tokyocameraclub.com/nikkor_users_gallery/"><img src="/img_report_nikon/bnr_03.jpg" alt="ニッコールユーザーズギャラリー"></a>
                    </div><!-- /inner4-->
                </section><!-- /bnrBlock3-->

                <section class="btnBlock">
                    <div class="inner4">
                      <router-link to="/talkshows" class="StandardBtn">オンライントークショートップ</router-link>
                    </div><!-- /inner4-->
                </section><!-- /btnBlock-->

            </div><!-- /reportBody-->

        </section><!-- /report-->

    </div><!-- /main-->
    <Footer />
    <UpButton />
    <QuestionnaireButton />
  </div>
</template>
<script>
import HeaderTalkshows from '@/components/modules/HeaderTalkshows.vue'
import BreadcrumbList from '@/components/modules/BreadcrumbList.vue'
import Footer from '@/components/modules/Footer.vue'
import UpButton from '@/components/modules/UpButton.vue'
import QuestionnaireButton from '@/components/modules/QuestionnaireButton.vue'

export default {
  components: {
    HeaderTalkshows,
    BreadcrumbList,
    Footer,
    UpButton,
    QuestionnaireButton
  },
  data () {
    return {
      pageNo: 1
    }
  },
  created () {
  },
  methods: {
    setPage (num) {
      this.pageNo = num
    },
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    }
  },
  computed: {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.withRightLine {
  border-right: 1px solid #000;
}
.withLeftLine {
  border-left: 1px solid #000;
}

</style>
